module.exports = __webpack_public_path__ + "static/media/good-practice-statement.0766d034.svg";